import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";
import type { TFunction } from "i18next";
import { toWorkspacePath } from "@/features/Workspaces/workspaceRoutes";

import { getAuditColumns } from "@/pages/a7/Audit/getAuditColumns";

export type A7FIAIssuer = {
  id: string;
  name: string;
  code: string;
  manager_name: string;
  manager_contact: string;
  business_manager: string;
  identifiant_fiscal_du_sous_jacent: string;
  societe_mere_id?: number;
  societe_mere_name?: string;
};

const tableName = "a7_fia_issuers";

export const getIssuersColumns = (t: TFunction): ColumnDef<A7FIAIssuer>[] => {
  const tTable = (key: string, defaultValue: string) =>
    t(`${tableName}.columns.${key}`, { ns: "tables", defaultValue });

  return [
    {
      accessorKey: "id",
      header: tTable("id", "ID"),
    },
    {
      accessorKey: "denomination_du_sous_jacent",
      header: tTable("denomination_du_sous_jacent", "Name"),
    },
    {
      accessorKey: "lei",
      header: tTable("lei", "LEI"),
    },
    {
      accessorKey: "identifiant_fiscal_du_sous_jacent",
      header: tTable("identifiant_fiscal_du_sous_jacent", "Tax identifier"),
    },
    {
      accessorKey: "societe_mere_name",
      header: tTable("societe_mere_name", "Parent company name"),
      cell: ({ row }) => {
        return (
          <Link
            href={toWorkspacePath(
              `/admin/a7-fia/a7_fia_issuers/${row.original.societe_mere_id}`,
            )}
            className="text-xs"
            underline="hover"
          >
            {row.getValue("societe_mere_name")}
          </Link>
        );
      },
    },
    {
      id: "actions",
      cell: ({ row }) => {
        return (
          <div className="flex justify-end">
            <Link
              href={`${window.location.pathname}/${row.getValue("id")}`}
              className="text-xs"
              underline="hover"
            >
              {t("actions.edit", { ns: "common", defaultValue: "Edit" })}
            </Link>
          </div>
        );
      },
    },
  ];
};

export const getIssuerAuditColumns = (t: TFunction) =>
  getAuditColumns<A7FIAIssuer>(getIssuersColumns(t)).filter((column) => {
    if (!("accessorKey" in column)) return true;
    return column.accessorKey !== "id";
  });
